"use client";

import React from "react";
import { SiX, SiLinkedin, SiYoutube, SiInstagram } from "react-icons/si";

const Footer2 = () => {
  return (
    <footer className="relative bg-zinc-50 text-black pt-32 pb-10 border-t border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 lg:gap-8 mb-16">
          <div className="space-y-4 md:w-1/3">
             <div className="relative w-12 h-12 rounded-xl overflow-hidden bg-zinc-100 shadow-sm">
               <img src="/new-logo.png" alt="Senera" className="object-cover w-full h-full" />
             </div>
             <p className="text-zinc-600 text-sm max-w-xs">
               We consult & develop AI Systems that help businesses scale efficiently without linear hiring.
             </p>
          </div>

          <div className="flex flex-wrap gap-12 md:gap-24">
            {/* Company */}
            <div className="space-y-6">
              <h3 className="text-zinc-600 font-medium text-sm">Company</h3>
              <ul className="space-y-4">
                <li><a href="/about" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm">About</a></li>
                <li><a href="/blog" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm">Blog</a></li>
                <li><a href="https://cut-eris-55d.notion.site/32191048854080808b5ecef98c7eca1b?pvs=105" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm">Careers</a></li>
                <li><a href="/contact" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm">Contact</a></li>
              </ul>
            </div>

            {/* Legal */}
            <div className="space-y-6">
              <h3 className="text-zinc-600 font-medium text-sm">Legal</h3>
              <ul className="space-y-4">
                <li><a href="/legal/terms" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm">Terms of Service</a></li>
                <li><a href="/legal/privacy" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm">Privacy Policy</a></li>
                <li><a href="/legal/security" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm">Security</a></li>
              </ul>
            </div>

            {/* Connect */}
          <div className="space-y-6">
            <h3 className="text-zinc-600 font-medium text-sm">Connect</h3>
            <ul className="space-y-4">
              <li>
                <a href="https://x.com/seneracore" target="_blank" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm flex items-center gap-2">
                  <SiX className="w-3 h-3" /> X (Twitter)
                </a>
              </li>
              <li>
                <a href="https://instagram.com/seneracore" target="_blank" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm flex items-center gap-2">
                  <SiInstagram className="w-3 h-3" /> Instagram
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/seneracore/" target="_blank" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm flex items-center gap-2">
                  <SiLinkedin className="w-3 h-3" /> LinkedIn
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/@SeneraCore" target="_blank" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm flex items-center gap-2">
                  <SiYoutube className="w-3 h-3" /> YouTube
                </a>
              </li>
              <li>
                <a href="mailto:hello@seneracore.com" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm">
                  hello@seneracore.com
                </a>
              </li>
              <li>
                <a href="tel:+919893823273" className="text-zinc-700 hover:text-indigo-600 transition-colors text-sm">
                  +91 98938 23273
                </a>
              </li>
            </ul>
          </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-zinc-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-6">
            <span className="text-zinc-600 text-xs">© 2026 Senera Core</span>
            <span className="text-zinc-600 text-xs flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-zinc-900 animate-pulse"></span>
              All Systems Operational
            </span>
          </div>

          <div className="flex items-center gap-4">
            <div className="flex items-center px-3 py-1.5 rounded-full bg-white border border-zinc-200 text-zinc-600 text-xs hover:text-indigo-600 hover:border-zinc-400 transition-colors cursor-pointer gap-2 shadow-sm">
              <div className="w-2 h-2 rounded-full bg-zinc-500"></div>
              English
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer2;
